interface MetricCardProps {
  label: string;
  value: string;
  detail?: string;
  loading?: boolean;
  variant?: "default" | "hero";
}

export function MetricCard({
  label,
  value,
  detail,
  loading,
  variant = "default",
}: MetricCardProps) {
  const hero = variant === "hero";

  return (
    <article
      className={[
        "relative rounded-[15px] border p-[22px] shadow-[0_3px_10px_#303c4e03]",
        hero
          ? "stat-card-hero border-0 bg-gradient-to-br from-[#0c5745] to-[#187b61] text-white"
          : "border-edlab-line bg-white",
      ].join(" ")}
    >
      <p
        className={[
          "mb-[18px] flex items-center justify-between text-[13px] font-medium",
          hero ? "text-[#bcdcd0]" : "text-[#7a8590]",
        ].join(" ")}
      >
        {label}
      </p>
      {loading ? (
        <div className="mb-[14px] h-8 w-24 animate-pulse rounded bg-edlab-bg" />
      ) : (
        <p
          className={[
            "mb-[14px] text-[28px] font-[650] tracking-[-0.8px] tabular-nums",
            hero ? "text-[31px] text-white" : "text-edlab-ink",
          ].join(" ")}
        >
          {value}
        </p>
      )}
      {detail && !loading ? (
        <p
          className={[
            "flex items-center gap-[5px] text-xs leading-normal",
            hero ? "text-[#bcdcd0]" : "text-[#7b8591]",
          ].join(" ")}
        >
          {detail}
        </p>
      ) : null}
    </article>
  );
}
